<template>
  <div class="reports-page">
    <div class="content-header">
      <h4 class="text-color-2">รายงานการจัดส่ง</h4>
    </div>

    <div class="row">
      <div class="col-12">
        <Card>
          <div slot="body">
            <div v-if="loading">
              <Spinner size="md"
                       variation="primary" />
            </div>

            <div v-else>
              <!-- Toolbar -->
              <div class="d-flex mb-4">
                <DatePicker id="date-range"
                            custom_class="align-self-center mr-2 mb-0"
                            v-model="shipmentsReportForm.fromDate"
                            :placeholder="'เลือกวันที่เริ่ม'" />

                <DatePicker id="date-range"
                            custom_class="align-self-center mr-2 mb-0"
                            v-model="shipmentsReportForm.toDate"
                            :placeholder="'เลือกวันที่สิ้นสุด'" />

                <Select id="shippers"
                        form_group_class="align-self-center mr-4 mb-0"
                        :options="shipperOptions"
                        v-model="shipmentsReportForm.shipperId" />

                <Select id="status"
                        form_group_class="align-self-center mr-4 mb-0"
                        :options="statusOptions"
                        v-model="shipmentsReportForm.status" />

                <Button id="btnExport"
                        variant="success"
                        size="sm"
                        @click="getShipmentsReports('csv')"
                        :disabled="shipmentsReportForm.loading"
                        :loading="shipmentsReportForm.loading"
                        custom_class="align-self-center mr-4">โหลดไฟล์ Excel</Button>

                <Button id="btnGetReport"
                        variant="success"
                        size="sm"
                        @click="getShipmentsReports('json')"
                        :disabled="shipmentsReportForm.loading"
                        :loading="shipmentsReportForm.loading"
                        custom_class="align-self-center">แสดงรายงาน</Button>
              </div>
            </div>

            <div v-if="orders && orders.length">
              <table class="table _datatable orders-table --very-small-height">
                <thead>
                  <tr>
                    <th>เลขแทร็ค</th>
                    <th>วันที่</th>
                    <th>สถานะ</th>
                    <th>ลูกค้า</th>
                    <th>ที่อยู่ผู้รับ</th>
                    <th>น้ำหนัก</th>
                    <th>ราคาที่คิดลูกค้า</th>
                    <th>หมายเลขอ้างอิง</th>
                    <th>หมายเหตุ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in orders"
                      :key="index">

                    <td>
                      <div class="d-flex flex-column">
                        <p>{{ order.trackingNo }}</p>
                        <p>{{ order.billNo.split("__")[0] }}</p>
                      </div>
                    </td>
                    <td>{{ order.createdAt }}</td>

                    <td v-html="tdHtml('status', order.status.value)"
                        class="--width-md"></td>

                    <td class="--width-md"
                        v-html="tdHtml('shipper', order.shipper)">
                    </td>

                    <td class="--width-md">
                      {{ order.addr }}
                      {{ order.dist }}
                      {{ order.subDist }}
                      {{ order.prov }}
                      {{ order.zip }}
                    </td>

                    <td>
                      {{ order.weight }}
                    </td>

                    <td>
                      {{ order.price }}
                    </td>

                    <td>
                      {{ order.rerNo }}
                    </td>

                    <td>
                      {{ order.note }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/core/DatePicker";
import Card from "@/components/core/Card";
import Button from "@/components/core/Button";
import Select from "@/components/core/Select";
import moment from "moment-timezone";
import { i18n } from "@/i18n";
import { FILTERS } from "@/helpers/filters";
import { Toast } from "@/helpers/toastr";
import { getBillStatus } from "@/helpers/core";
import fileDownload from "js-file-download";
import Spinner from "@/components/core/Spinner";

export default {
  name: "ShipmentsReport",
  components: { Card, DatePicker, Button, Spinner, Select },

  data() {
    return {
      loading: false,
      shipmentsReportForm: {
        fromDate: null,
        toDate: null,
        shipperId: null,
        status: null,
        loading: false,
      },
      shippers: null,
      shipperOptions: null,
      orders: null
    };
  },

  async created() {
    await this.fetchShippers();
  },

  methods: {
    tdHtml(type, value) {
      const types = {
        status: (value) => {
          let statusData = getBillStatus(value);
          if (!statusData) return value;
          return `<span class="badge badge-pill text-uppercase status-badge --${statusData.variation}">${statusData.title}</span>`;
        },
        shipper: (value) => {
          return value.name
        },

        createdAtDate: (value) => {
          return FILTERS.formatDate(value);
        },

        createdAtTime: (value) => {
          return FILTERS.formatTime(value);
        },

        ellipsis: (value) => {
          return FILTERS.ellipsis(value, 15);
        },
      };
      return types[type] ? types[type](value) : value;
    },

    async getShipmentsReports(format = "json") {
      if (format == "json") this.shipments = null;
      this.shipmentsReportForm.loading = true;

      let from = moment
        .tz(this.shipmentsReportForm.fromDate, "Asia/Bangkok")
        .startOf("day")
        .valueOf();
      let to = moment
        .tz(this.shipmentsReportForm.toDate, "Asia/Bangkok")
        .endOf("day")
        .valueOf();
      if (!from || !to) {
        Toast("From & To dates must exist", "danger");
        this.shipmentsReportForm.loading = false;
        return;
      }

      const { status, data } = await this.$store.dispatch("orders/fetchOrdersReport", {
        params: {
          from,
          to,
          format,
          shipperId: this.shipmentsReportForm.shipperId,
          status: this.shipmentsReportForm.status
        }
      });
      if (status) {
        if (format == "csv") {
          const binaryString = window.atob(data); // Decode base64 string
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) bytes[i] = binaryString.charCodeAt(i);
          const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fileDownload(blob, "orders_report.xlsx");
        } else this.orders = data;
      }
      this.shipmentsReportForm.loading = false;
    },

    async fetchShippers() {
      this.loading = true;

      const { status, data } = await this.$store.dispatch("shippers/fetchShippers", {
        params: {
          perPage: 1000
        }
      });

      if (status) {
        this.shipperOptions = data.shippers.map(s => {
          return { name: s.name, value: s.id }
        })
        this.shipperOptions.unshift({ name: "ทั้งหมด", value: "all" });
        this.shipmentsReportForm.shipperId = this.shipperOptions[0].value;
      }
      this.loading = false;
    }
  },

  computed: {
    statusOptions() {
      let arr = [{ name: i18n.t("tabs.all"), value: 0 }];
      let ORD_STS = getBillStatus();
      Object.keys(ORD_STS).forEach((status) => {
        arr.push({ name: ORD_STS[status].title, value: status });
      });
      return arr;
    },
  },
};
</script>

<style lang="scss"
       scoped>
      .reports-page {
        margin: 35px;
      }
    </style>